import React, { useState } from 'react';
import { DateRangeForm } from 'src/components/DateRangeForm/DateRangeFormNew';
import { observer } from 'src/utils/mobx-react';
import { FreeSpinTransactionHistoryTabState } from './FreeSpinTransactionHistoryTab.state';
import { TransactionsList } from 'src/components/CustomersBar/CustomerTab/FreeSpinTransactionHistoryTab/TransactionsList/TransactionsList';
import { TransactionHistoryTabContent } from 'src/components/CustomersBar/CustomerTab/FreeSpinTransactionHistoryTab/TransactionsList/TransactionList.style';
import { useAppStateContext } from 'src/AppState/AppState';

interface FreeSpinTransactionHistoryTabPropsType {
    id: number;
}

export const FreeSpinTransactionHistoryTab = observer(
    'FreeSpinTransactionHistoryTab',
    ({ id }: FreeSpinTransactionHistoryTabPropsType) => {
        const { routerBackoffice } = useAppStateContext();
        const [state] = useState(() => new FreeSpinTransactionHistoryTabState(id, routerBackoffice));
        const { range, handleOnUpdateDate, assetFlowsListLength } = state;
        const isDisabled = assetFlowsListLength === 0;

        return (
            <TransactionHistoryTabContent>
                <DateRangeForm
                    data={range}
                    handleOnUpdateDate={handleOnUpdateDate}
                    isDisabled={isDisabled}
                />

                <TransactionsList
                    name='all'
                    state={state}
                />
            </TransactionHistoryTabContent>
        );
    }
);
